export default function() {
  
  const widgetName = 'swiperWidget-tier3';
  const widgetOpts = swiperWidgetSlideshowOpts;
 

  // Template
  function buildSlideTemplate(slide) {

    const description = `<span class="swiper-description">${slide.Description}</span>`;

    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container" style="background-image: url('${slide.ImageWithPath}');" aria-label="${slide.ImageAlternateText}"></div>
        <div class="swiper-content-container">
          <div class="swiper-content">
            ${description}
          </div>
        </div>
      </div>
    `;

    return template;
  }



  // Fetch data
  saffire.utils.getWidgetData(widgetOpts).then(function(response) {
    if (response.Slides.length > 0) {
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget-tier3');
    }
  });


  // Initialize Swiper
  function initSwiper(widgetData) {

    const swiperWidgetWrapper = $('.swiperWidget-tier3 .swiper-wrapper');

    widgetData.forEach(function(slide, i) {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    let isMobileSize = $('body').hasClass('saffireMobileSize') ? true : false;

    $(window).resize(function() {
      if ($('body').hasClass('saffireMobileSize')) {
        isMobileSize = true;
      } else {
        isMobileSize = false;
      }
    });

    function initDesktopSwiper()  {
      const swiperWidgetInit = new Swiper('.swiperWidget-tier3 .swiper-container', {
        speed: 300,
        autoplay: false,
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        autoHeight: true,
        loop: true,
        effect: 'slide',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: function() {
            $('.swiperWidget-tier3').removeClass('m-swiper');
          },
          resize: function() {
            if (!isMobileSize) {
              swiperWidgetInit.update()
            } else {
              swiperWidgetInit.destroy();
              initMobileSwiper();
            }
          },
          update: function() {
            setTimeout(function() {
              swiperWidgetInit.updateSlides()
              swiperWidgetInit.updateSize()
              swiperWidgetInit.slideReset()
            }, 1000)
          }
        }
      });
    }

    function initMobileSwiper()  {
      const swiperWidgetInit = new Swiper('.swiperWidget-tier3 .swiper-container', {
        speed: 300,
        autoplay: false,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 10,
        autoHeight: false,
        loop: true,
        effect: 'slide',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: function() {
            $('.swiperWidget-tier3').addClass('m-swiper');
          },
          resize: function() {
            if (!isMobileSize) {
              swiperWidgetInit.destroy();
              initDesktopSwiper();
            }
          }
        }
      });
    }

    if (!isMobileSize) {
      initDesktopSwiper();
    } else {
      initMobileSwiper();
    }



  }

}





